import React from 'react';
import {SubmitFieldConfig} from './TYPE_SubmitFieldConfig';
import {isMasterFirebaseUser} from '../../library/GeneralUse';
import {useFirebaseAuthUserStore} from '../../stores/FirebaseAuthUserStore';

const style = {
	textarea: `p-2   h-18 recommended:h-24      bg-whirlwindDark   border-l-2 border-whirlwindPrimary   resize-none   scrollbar-webkit`,
	input: `p-2   h-6 recommended:h-12   bg-whirlwindDark   border-l-2 border-whirlwindPrimary`,
};

export const SubmitField = ({
	fieldVal,
	id,
	isTextArea,
	maxLength,
	onlyForMaster,
	placeholder,
	setFieldVal,
}: SubmitFieldConfig) => {
	// Zustand
	const firebaseAuthUser = useFirebaseAuthUserStore(
		(state) => state.firebaseAuthUser,
	);

	if (onlyForMaster) {
		if (isMasterFirebaseUser(firebaseAuthUser?.uid)) {
			return (
				<>
					{isTextArea ? (
						<textarea
							className={style.textarea}
							data-test-id={`${id}_TEST`}
							id={id}
							maxLength={maxLength}
							minLength={1}
							onChange={(event) => {
								setFieldVal(event.target.value);
							}}
							placeholder={placeholder}
							value={fieldVal}
						/>
					) : (
						<input
							className={style.input}
							data-test-id={`${id}_TEST`}
							id={id}
							maxLength={maxLength}
							minLength={1}
							onChange={(event) => {
								setFieldVal(event.target.value);
							}}
							placeholder={placeholder}
							value={fieldVal}
						/>
					)}
				</>
			);
		}
	} else {
		return (
			<>
				{isTextArea ? (
					<textarea
						className={style.textarea}
						data-test-id={`${id}_TEST`}
						id={id}
						maxLength={maxLength}
						minLength={1}
						onChange={(event) => {
							setFieldVal(event.target.value);
						}}
						placeholder={placeholder}
						value={fieldVal}
					/>
				) : (
					<input
						className={style.input}
						data-test-id={`${id}_TEST`}
						id={id}
						maxLength={maxLength}
						minLength={1}
						onChange={(event) => {
							setFieldVal(event.target.value);
						}}
						placeholder={placeholder}
						value={fieldVal}
					/>
				)}
			</>
		);
	}

	return <></>;
};
